export default __webpack_public_path__ + "static/media/img-guide-gt-popup-3-kr_kr.d06ea508.png";